import React from 'react'
import styled from 'styled-components'
// import { IntlProvider, FormattedMessage } from 'react-intl'
import mountain from 'assets/images/auth/mountain.svg'
import Card from 'react-bootstrap/Card'
import Image from 'react-bootstrap/Image'
const MissionsContanier = styled.div``
const MissionCard = styled(Card)`
  border-radius: 20px;
  box-shadow: 0 6px 26px 0 rgba(0, 0, 0, 0.08);
`
const CardBody = styled(Card.Body)`
  line-height: 3.5;
  text-align: center;
`
const MountImage = styled(Image)`
  width: 5.313em;
  height: 5.313em;
`

export default function MissionsContent() {
  return (
    <div>
      <MissionsContanier className="mt-5">
        <MissionCard className="justify-content-md-center">
          <CardBody className="p-5">
            <MountImage src={mountain} />
            <h5 className="mt-2">
              Stay tuned for awesome missions, quests and amazing rewards
            </h5>
          </CardBody>
        </MissionCard>
      </MissionsContanier>
    </div>
  )
}
